// 正式
const baseUrl = window.serverConfig.baseUrl;

export {
  baseUrl
};
